export default "__VITE_ASSET__JZT6G9d8__"